var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _polygon, _polygon2, _circle9, _circle0, _circle1, _circle10, _circle11, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _rect2, _circle12, _ellipse6, _rect3, _circle13, _ellipse7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFantasyArt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 800,
    viewBox: "0 0 600 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "magicSky",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4D3B99",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#2D1B69",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#190A4E",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFB02E",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FFB02E",
      stopOpacity: 0
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 800,
    fill: "url(#magicSky)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 2,
    fill: "#FFFFFF",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 120,
    r: 2,
    fill: "#FFFFFF",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 150,
    r: 1.5,
    fill: "#FFFFFF",
    opacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 90,
    r: 2,
    fill: "#FFFFFF",
    opacity: 0.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 60,
    r: 1.5,
    fill: "#FFFFFF",
    opacity: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 200,
    r: 1,
    fill: "#00D9FF",
    opacity: 0.8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 180,
    r: 1,
    fill: "#00D9FF",
    opacity: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 250,
    r: 80,
    fill: "url(#glow)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "300,200 330,240 300,280 270,240",
    fill: "#FFB02E",
    opacity: 0.8
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "300,200 315,220 300,240 285,220",
    fill: "#FFFFFF",
    opacity: 0.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 200,
    r: 4,
    fill: "#00D9FF",
    opacity: 0.7
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 220,
    r: 3,
    fill: "#FFB02E",
    opacity: 0.6
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 310,
    r: 3.5,
    fill: "#00D9FF",
    opacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 290,
    r: 3,
    fill: "#FFFFFF",
    opacity: 0.7
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 270,
    r: 2.5,
    fill: "#FFB02E",
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 600 L100 450 L150 450 L150 480 L170 480 L170 430 L220 430 L220 460 L240 460 L240 420 L290 420 L290 600 Z",
    fill: "#2D1B69",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310 600 L310 420 L360 420 L360 460 L380 460 L380 430 L430 430 L430 480 L450 480 L450 450 L500 450 L500 600 Z",
    fill: "#2D1B69",
    opacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 650,
    rx: 40,
    ry: 80,
    fill: "#3D2B89",
    opacity: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 680,
    rx: 35,
    ry: 70,
    fill: "#3D2B89",
    opacity: 0.6
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 420,
    cy: 660,
    rx: 45,
    ry: 85,
    fill: "#3D2B89",
    opacity: 0.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 480,
    cy: 690,
    rx: 38,
    ry: 75,
    fill: "#3D2B89",
    opacity: 0.6
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 750,
    rx: 20,
    ry: 15,
    fill: "#00D9FF",
    opacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 750,
    width: 10,
    height: 30,
    fill: "#00D9FF",
    opacity: 0.4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 750,
    r: 25,
    fill: "#00D9FF",
    opacity: 0.2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 530,
    cy: 760,
    rx: 18,
    ry: 13,
    fill: "#FFB02E",
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 760,
    width: 8,
    height: 25,
    fill: "#FFB02E",
    opacity: 0.4
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 760,
    r: 22,
    fill: "#FFB02E",
    opacity: 0.2
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 780,
    rx: 250,
    ry: 30,
    fill: "#FFFFFF",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantasyArt);
export default __webpack_public_path__ + "static/media/fantasy-art.ffbdf7e66431ae5c473e3fbc6b557bb6.svg";
export { ForwardRef as ReactComponent };